var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBarcode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 4,
    y: 4.14685,
    width: 8,
    height: 16,
    fill: "#4A4B68"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 9.14685V6.14685H9C9 6.14685 10 6.14685 10 5.14685C10 4.14685 9 4.14685 9 4.14685H4V9.14685C4 9.14685 4.17157 10.1469 5 10.1469C5.82843 10.1469 6 9.14685 6 9.14685ZM18 6.14696H15C15 6.14696 14 5.97538 14 5.14696C14 4.31853 15 4.14696 15 4.14696H20V9.14696C20 9.14696 20 10.147 19 10.147C18 10.147 18 9.14696 18 9.14696V6.14696ZM9 18.1469H6V15.1469C6 15.1469 6 14.1469 5 14.1469C4 14.1469 4 15.1469 4 15.1469V20.1469H9C9 20.1469 10 19.9753 10 19.1469C10 18.3184 9 18.1469 9 18.1469ZM18 15.1469V18.1469H15C15 18.1469 14 18.1469 14 19.1469C14 20.1469 15 20.1469 15 20.1469H20V15.1469C20 15.1469 19.8284 14.1469 19 14.1469C18.1716 14.1469 18 15.1469 18 15.1469Z",
    fill: "#4A4B68"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarcode);
export default __webpack_public_path__ + "static/media/Barcode.0ca98e990347ec38add21fcec4571f94.svg";
export { ForwardRef as ReactComponent };